import PropTypes from "prop-types";
import React from "react";

import CommentForm from "components/CommentForm";
import CommentItem from "components/CommentItem";
import { useCommentContext } from "widgets/Comments/CommentContext";

import "./_style.scss";

const CommentList = ({ comments = [] }) => {
  const { replyToId, isCreating } = useCommentContext();

  const renderComment = (comment, index, isInThread = false, parentCommentId = null) => (
    <CommentItem
      commentText={comment.content}
      id={comment.id}
      image={comment.image}
      isAnonymous={!!comment.anonymous}
      isDisabled={isCreating}
      isInThread={isInThread}
      name={comment.full_name}
      parentCommentId={parentCommentId}
      timestamp={comment.timestamp}
    />
  );

  const renderForm = (isInThread = false, parentCommentId = null) => (
    <CommentForm isInThread={isInThread} parentCommentId={parentCommentId} />
  );

  const renderWithThread = (comment, index) => {
    const parentCommentId = comment.id;

    return (
      <div className="comment-list__item" key={comment.id ?? index}>
        {renderComment(comment, index, false, parentCommentId)}

        <div className="comment-list__thread">
          {Array.isArray(comment.replies)
            && comment.replies.map((reply, replyIndex) => (
              <div className="comment-list__item" key={reply.id ?? `${comment.id}-${replyIndex}`}>
                {renderComment(reply, replyIndex, true, parentCommentId)}
              </div>
            ))}

          {replyToId === comment.id ? renderForm(true, parentCommentId) : null}
        </div>
      </div>
    );
  };

  return (
    <div className="comment-list">
      {comments.length > 0
        && comments.map((comment, index) => {
          const hasReplies = Array.isArray(comment.replies) && comment.replies.length > 0;

          if (hasReplies) {
            return renderWithThread(comment, index);
          }

          if (replyToId === comment.id) {
            return (
              <div key={comment.id ?? index}>
                <div className="comment-list__item">{renderComment(comment, index, false)}</div>
                {renderForm(false, comment.id)}
              </div>
            );
          }

          return (
            <div className="comment-list__item" key={comment.id ?? index}>
              {renderComment(comment, index, false)}
            </div>
          );
        })}
    </div>
  );
};

CommentList.propTypes = {
  comments: PropTypes.array.isRequired,
};

export default CommentList;
